import { render, staticRenderFns } from "./RenunciaDetail.vue?vue&type=template&id=2d1be523"
import script from "./RenunciaDetail.vue?vue&type=script&lang=js"
export * from "./RenunciaDetail.vue?vue&type=script&lang=js"
import style0 from "./RenunciaDetail.vue?vue&type=style&index=0&id=2d1be523&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports